import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [
                {
                    text: [
                        'article-badge',
                        'article-h1',
                        'article-h2',
                        'article-h3',
                        'article-dek',
                        'article-body',
                        'article-quote',
                        'article-break-lead',
                        'article-impact',
                    ],
                },
            ],
        },
    },
})

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
